(function(){
  function init(root){
    if(!root||root.dataset.mhReceiveReady==='true')return;
    root.dataset.mhReceiveReady='true';
    var tabs=[].slice.call(root.querySelectorAll('[data-mh-receive-tab]'));
    var panels=[].slice.call(root.querySelectorAll('[data-mh-receive-panel]'));
    var form=root.querySelector('[data-mh-receive-zip]');
    var input=form&&form.querySelector('input[name="postal_code"]');
    var status=root.querySelector('[data-mh-receive-zip-status]');

    function select(tab){
      var key=tab.dataset.mhReceiveTab;
      tabs.forEach(function(item){var active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false');item.setAttribute('tabindex',active?'0':'-1')});
      panels.forEach(function(panel){panel.hidden=panel.dataset.mhReceivePanel!==key});
    }
    tabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){select(tab)});
      tab.addEventListener('keydown',function(event){if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;event.preventDefault();var next=event.key==='ArrowRight'?(index+1)%tabs.length:(index-1+tabs.length)%tabs.length;tabs[next].focus();select(tabs[next])});
    });
    select(root.querySelector('[data-mh-receive-tab].is-active')||tabs[0]);

    if(form&&input){
      form.addEventListener('submit',function(event){
        event.preventDefault();
        var zip=input.value.replace(/\D/g,'').slice(0,5);input.value=zip;
        status.classList.remove('is-valid','is-error');
        if(!/^\d{5}$/.test(zip)){status.textContent='Enter a valid 5-digit ZIP code.';status.classList.add('is-error');input.focus();return}
        root.querySelectorAll('[data-mh-receive-current-zip]').forEach(function(node){node.textContent=zip});
        status.textContent='ZIP '+zip+' applied. Select Delivery or Pickup to review the options.';status.classList.add('is-valid');
        try{sessionStorage.setItem('mh_delivery_zip',zip)}catch(error){}
      });
      try{var saved=sessionStorage.getItem('mh_delivery_zip');if(saved&&/^\d{5}$/.test(saved)){input.value=saved;root.querySelectorAll('[data-mh-receive-current-zip]').forEach(function(node){node.textContent=saved})}}catch(error){}
    }
  }
  function initAll(scope){(scope||document).querySelectorAll('[data-mh-receive]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();
